module.exports = __webpack_public_path__ + "static/media/Secure.aef1c4ba.svg";